/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createSiteSettings } from '../fn/administration/create-site-settings';
import { CreateSiteSettings$Params } from '../fn/administration/create-site-settings';
import { downloadMonthlyDeliveryNoteReport } from '../fn/administration/download-monthly-delivery-note-report';
import { DownloadMonthlyDeliveryNoteReport$Params } from '../fn/administration/download-monthly-delivery-note-report';
import { getAdministrationDeliveryNotesReportCsv } from '../fn/administration/get-administration-delivery-notes-report-csv';
import { GetAdministrationDeliveryNotesReportCsv$Params } from '../fn/administration/get-administration-delivery-notes-report-csv';
import { getAllOrganizationSiteSettings } from '../fn/administration/get-all-organization-site-settings';
import { GetAllOrganizationSiteSettings$Params } from '../fn/administration/get-all-organization-site-settings';
import { getSiteSettings } from '../fn/administration/get-site-settings';
import { GetSiteSettings$Params } from '../fn/administration/get-site-settings';
import { listMonthlyDeliveryNoteReports } from '../fn/administration/list-monthly-delivery-note-reports';
import { ListMonthlyDeliveryNoteReports$Params } from '../fn/administration/list-monthly-delivery-note-reports';
import { MonthlyDeliveryNoteReportsList } from '../models/monthly-delivery-note-reports-list';
import { NotificationSettingResponse } from '../models/notification-setting-response';
import { replaceNotificationSetting } from '../fn/administration/replace-notification-setting';
import { ReplaceNotificationSetting$Params } from '../fn/administration/replace-notification-setting';
import { SettingResponse } from '../models/setting-response';

@Injectable({ providedIn: 'root' })
export class AdministrationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSiteSettings()` */
  static readonly GetSiteSettingsPath = '/organization-sites/{organizationSiteKey}/settings';

  /**
   * Get the site settings.
   *
   * Gets the settings configured for a site (for example email notification settings).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSiteSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSiteSettings$Response(params: GetSiteSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingResponse>> {
    const obs = getSiteSettings(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the site settings.
   *
   * Gets the settings configured for a site (for example email notification settings).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSiteSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSiteSettings(params: GetSiteSettings$Params, context?: HttpContext): Observable<SettingResponse> {
    const resp = this.getSiteSettings$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SettingResponse>): SettingResponse => r.body)
    );
  }

  /** Path part for operation `createSiteSettings()` */
  static readonly CreateSiteSettingsPath = '/organization-sites/{organizationSiteKey}/settings';

  /**
   * Create new site settings.
   *
   * Create new site settings (for example, e-mail notification settings).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSiteSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSiteSettings$Response(params: CreateSiteSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingResponse>> {
    const obs = createSiteSettings(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create new site settings.
   *
   * Create new site settings (for example, e-mail notification settings).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSiteSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSiteSettings(params: CreateSiteSettings$Params, context?: HttpContext): Observable<SettingResponse> {
    const resp = this.createSiteSettings$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SettingResponse>): SettingResponse => r.body)
    );
  }

  /** Path part for operation `getAllOrganizationSiteSettings()` */
  static readonly GetAllOrganizationSiteSettingsPath = '/organization-sites/settings';

  /**
   * Get settings from all organization sites.
   *
   * Retrieve settings from all organization sites.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOrganizationSiteSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOrganizationSiteSettings$Response(params?: GetAllOrganizationSiteSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SettingResponse>>> {
    const obs = getAllOrganizationSiteSettings(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get settings from all organization sites.
   *
   * Retrieve settings from all organization sites.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllOrganizationSiteSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOrganizationSiteSettings(params?: GetAllOrganizationSiteSettings$Params, context?: HttpContext): Observable<Array<SettingResponse>> {
    const resp = this.getAllOrganizationSiteSettings$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SettingResponse>>): Array<SettingResponse> => r.body)
    );
  }

  /** Path part for operation `replaceNotificationSetting()` */
  static readonly ReplaceNotificationSettingPath = '/organization-sites/{organizationSiteKey}/settings/notifications';

  /**
   * Replace the notification settings.
   *
   * Replace notification settings of a site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceNotificationSetting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceNotificationSetting$Response(params: ReplaceNotificationSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationSettingResponse>> {
    const obs = replaceNotificationSetting(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Replace the notification settings.
   *
   * Replace notification settings of a site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `replaceNotificationSetting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceNotificationSetting(params: ReplaceNotificationSetting$Params, context?: HttpContext): Observable<NotificationSettingResponse> {
    const resp = this.replaceNotificationSetting$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NotificationSettingResponse>): NotificationSettingResponse => r.body)
    );
  }

  /** Path part for operation `getAdministrationDeliveryNotesReportCsv()` */
  static readonly GetAdministrationDeliveryNotesReportCsvPath = '/administration/organization-sites/{organizationSiteKey}/delivery-notes/reports/csv';

  /**
   * Get delivery note reports as zip file for the provided organization site.
   *
   * Retrieve multiple CSV files (delivery notes metadata, articles, discrepancies,
   * load carriers consignor, load carriers consignee) as a ZIP file for
   * all delivery notes of the specified organization site.
   * Constrain: from <= timestamp < to, from and to must be milliseconds.
   * Allowed time range is 35 days. All times are in UTC.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAdministrationDeliveryNotesReportCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationDeliveryNotesReportCsv$Response(params: GetAdministrationDeliveryNotesReportCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = getAdministrationDeliveryNotesReportCsv(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get delivery note reports as zip file for the provided organization site.
   *
   * Retrieve multiple CSV files (delivery notes metadata, articles, discrepancies,
   * load carriers consignor, load carriers consignee) as a ZIP file for
   * all delivery notes of the specified organization site.
   * Constrain: from <= timestamp < to, from and to must be milliseconds.
   * Allowed time range is 35 days. All times are in UTC.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAdministrationDeliveryNotesReportCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationDeliveryNotesReportCsv(params: GetAdministrationDeliveryNotesReportCsv$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.getAdministrationDeliveryNotesReportCsv$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `listMonthlyDeliveryNoteReports()` */
  static readonly ListMonthlyDeliveryNoteReportsPath = '/administration/delivery-notes/monthly-reports';

  /**
   * List available monthly delivery note reports for all sites the user has access to.
   *
   * Retrieve a list of all available monthly delivery note report ZIP files
   * across all sites the user has admin permissions for. Organization admins
   * see reports for all sites in their organization(s). Site admins see reports
   * for all sites where they have site admin permissions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMonthlyDeliveryNoteReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMonthlyDeliveryNoteReports$Response(params?: ListMonthlyDeliveryNoteReports$Params, context?: HttpContext): Observable<StrictHttpResponse<MonthlyDeliveryNoteReportsList>> {
    const obs = listMonthlyDeliveryNoteReports(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List available monthly delivery note reports for all sites the user has access to.
   *
   * Retrieve a list of all available monthly delivery note report ZIP files
   * across all sites the user has admin permissions for. Organization admins
   * see reports for all sites in their organization(s). Site admins see reports
   * for all sites where they have site admin permissions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMonthlyDeliveryNoteReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMonthlyDeliveryNoteReports(params?: ListMonthlyDeliveryNoteReports$Params, context?: HttpContext): Observable<MonthlyDeliveryNoteReportsList> {
    const resp = this.listMonthlyDeliveryNoteReports$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MonthlyDeliveryNoteReportsList>): MonthlyDeliveryNoteReportsList => r.body)
    );
  }

  /** Path part for operation `downloadMonthlyDeliveryNoteReport()` */
  static readonly DownloadMonthlyDeliveryNoteReportPath = '/administration/organization-sites/{organizationSiteKey}/delivery-notes/monthly-reports/{year}/{month}';

  /**
   * Download a specific monthly delivery note report ZIP file.
   *
   * Download the ZIP file containing all delivery note PDFs for a specific
   * month and organization site. The file must exist (have been generated
   * by the monthly report cronjob). Organization admins can download reports
   * for any site in their organization. Site admins can only download reports
   * for sites where they have site admin permissions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadMonthlyDeliveryNoteReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadMonthlyDeliveryNoteReport$Response(params: DownloadMonthlyDeliveryNoteReport$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = downloadMonthlyDeliveryNoteReport(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Download a specific monthly delivery note report ZIP file.
   *
   * Download the ZIP file containing all delivery note PDFs for a specific
   * month and organization site. The file must exist (have been generated
   * by the monthly report cronjob). Organization admins can download reports
   * for any site in their organization. Site admins can only download reports
   * for sites where they have site admin permissions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadMonthlyDeliveryNoteReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadMonthlyDeliveryNoteReport(params: DownloadMonthlyDeliveryNoteReport$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.downloadMonthlyDeliveryNoteReport$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
